import { isNil } from 'lodash'
import clusterSelectors from './cluster.selectors'

const submissionSelectors = {
    all: state => state.assignment.clusters.map(cluster => cluster.files).flat(),
    allSubmissionsDetailed: state => state.assignment.assignment.files,
    openedSubmissionId: state =>
        isNil(state.assignment.drawer.file.id) ? state.submission.openedSubmissionId : state.assignment.drawer.file.id, // to remove state.assignment.drawer.file.id when fully got rid of old assignment reducer
    groupsAtSubmissionOpenMoment: state => state.submission.groupsAtSubmissionOpenMoment,
    showSubmissionDrawer: state => state.assignment.drawer.showDrawer,
    openedSubmissionName: state => state.assignment.drawer.file.name,
    openedSubmissionPatterns: state => state.assignment.drawer.file.motifList,
    selectedVersionId: state => state.submission.selectedVersionId,
    isOpenedSubmissionInGroupX: state => {
        const groupXFiles = clusterSelectors.groupX(state)?.files || []
        const openedSubmissionId = submissionSelectors.openedSubmissionId(state)
        return groupXFiles.some(file => file.id === openedSubmissionId)
    },
    isOpenedSubmissionInGroupY: state => {
        const groupYFiles = clusterSelectors.groupY(state)?.files || []
        const openedSubmissionId = submissionSelectors.openedSubmissionId(state)
        return groupYFiles.some(file => file.id === openedSubmissionId)
    },
    selectedSubmissionIds: state => state.submission.selectedSubmissionIds,
    isSelected: id => state => state.submission.selectedSubmissionIds.includes(id),
    someIsSelected: fileIds => state => fileIds.some(id => submissionSelectors.isSelected(id)(state)),
    allAreSelected: fileIds => state => fileIds.every(id => submissionSelectors.isSelected(id)(state)),
    isOpened: id => state => submissionSelectors.openedSubmissionId(state) === id,
    someIsOpened: state => submissionSelectors.openedSubmissionId(state) !== null,
    submissionFromClustersById: id => state => state.assignment.clusters.map(cluster => cluster.files).flat().find(file => file.id === id),
    hasArchetypeFiles: state => state.assignment.clusters
        .flatMap(cluster => cluster.files)
        .some(file => file.is_archetype),
}

export const getSubmissionFromClustersById = (id, clusters) => clusters.map(cluster => cluster.files).flat().find(file => file.id === id)

export default submissionSelectors
